import {Component} from 'react'
import './index.css'
import TabItem from '../TabItem'
import AppItem from '../AppItem'
import Header from '../Header'

const tabsList = [
  {tabId: 'Housing & Utilities', displayText: 'Housing & Utilities'},
  {tabId: 'Communication', displayText: 'Communication'},
  {tabId: 'Travel', displayText: 'Travel'},
  {tabId: 'Finance', displayText: 'Finance'},
  {tabId: 'Entertainment', displayText: 'Entertainment'},
  {tabId: 'Health', displayText: 'Health'},
  {tabId: 'Leisure', displayText: 'Leisure'},
]

const appsList = [
  {
    appId: 0,
    appName: 'Electricity',
    imageUrl:
      'categories/icon_electricity.svg',
    category: 'Housing & Utilities',
  },
  {
    appId: 1,
    appName: 'LPG Gas',
    imageUrl:
      'categories/icon_lpg.svg',
    category: 'Housing & Utilities',
  },
  {
    appId: 2,
    appName: 'Water',
    imageUrl:
      'categories/icon_water.svg',
    category: 'Housing & Utilities',
  },
  {
    appId: 3,
    appName: 'Municipal taxes',
    imageUrl:
      'categories/icon_municipalTaxes.svg',
    category: 'Housing & Utilities',
  },
  {
    appId: 4,
    appName: 'Housing Society',
    imageUrl:
      'categories/icon_housingSociety.svg',
    category: 'Housing & Utilities',
  },
  {
    appId: 5,
    appName: 'Gas',
    imageUrl:
      'categories/icon_gas.svg',
    category: 'Housing & Utilities',
  },
  {
    appId: 6,
    appName: 'Rental',
    imageUrl:
      'categories/icon_rent.svg',
    category: 'Housing & Utilities',
  },
  {
    appId: 7,
    appName: 'Landline postpaid',
    imageUrl:
      'categories/icon_landlinePostpaid.svg',
    category: 'Communication',
  },
  {
    appId: 8,
    appName: 'Mobile prepaid',
    imageUrl:
      'categories/icon_mobilePrepaid.svg',
    category: 'Communication',
  },
  {
    appId: 9,
    appName: 'Mobile postpaid',
    imageUrl:
      'categories/icon_mobilePostpaid.svg',
    category: 'Communication',
  },
  {
    appId: 10,
    appName: 'FASTag',
    imageUrl:
      'categories/icon_fastag.svg',
    category: 'Travel',
  },
  {
    appId: 11,
    appName: 'NCMC Recharge',
    imageUrl:
      'categories/icon_ncmc.svg',
    category: 'Travel',
  },
  {
    appId: 12,
    appName: 'Loan repayment',
    imageUrl:
      'categories/icon_loanRepayment.svg',
    category: 'Finance',
  },
  {
    appId: 13,
    appName: 'Credit Card',
    imageUrl:
      'categories/icon_creditCard.svg',
    category: 'Finance',
  },
  {
    appId: 14,
    appName: 'Insurance',
    imageUrl:
      'categories/icon_insurance.svg',
    category: 'Finance',
  },
  {
    appId: 15,
    appName: 'Recurring deposit',
    imageUrl:
      'categories/icon_recurringDeposit.svg',
    category: 'Finance',
  },
  {
    appId: 16,
    appName: 'Education Fees',
    imageUrl:
      'categories/icon_educationFees.svg',
    category: 'Finance',
  },
  {
    appId: 17,
    appName: 'Donation',
    imageUrl:
      'categories/icon_donation.svg',
    category: 'Finance',
  },
  {
    appId: 18,
    appName: 'National Pension System',
    imageUrl:
      'categories/icon_nps.svg',
    category: 'Finance',
  },
  {
    appId: 19,
    appName: 'Broadband postpaid',
    imageUrl:
      'categories/icon_broadbandPostpaid.svg',
    category: 'Entertainment',
  },
  {
    appId: 20,
    appName: 'Cable TV',
    imageUrl:
      'categories/icon_cableTV.svg',
    category: 'Entertainment',
  },
  {
    appId: 21,
    appName: 'DTH',
    imageUrl:
      'categories/icon_dth.svg',
    category: 'Entertainment',
  },
  {
    appId: 22,
    appName: 'Subscription',
    imageUrl:
      'categories/icon_subscriptionFees.svg',
    category: 'Entertainment',
  },
  {
    appId: 23,
    appName: 'Hospital and Pathology',
    imageUrl:
      'categories/icon_hospitalAndPathology.svg',
    category: 'Health',
  },
  {
    appId: 25,
    appName: 'Hospital',
    imageUrl:
      'categories/icon_insurance.svg',
    category: 'Health',
  },
  {
    appId: 26,
    appName: 'Clubs and Associations',
    imageUrl:
      'categories/icon_clubsAndAssociations.svg',
    category: 'Leisure',
  },
]

// Write your code here
class AppStore extends Component {
  state = {activeTabId: tabsList[0].tabId, searchInput: ''}

  getFilteredApps = () => {
    const {activeTabId} = this.state
    const filteredApps = appsList.filter(
      eachApp => eachApp.category === activeTabId,
    )
    return filteredApps
  }

  onChangeSearchInput = event => {
    this.setState({searchInput: event.target.value})
  }

  getSearchResults = () => {
    const {searchInput, activeTabId} = this.state
    const searchResults = appsList.filter(
      eachItem =>
        eachItem.appName.toLowerCase().includes(searchInput.toLowerCase()) &&
        eachItem.category === activeTabId,
    )
    return searchResults
  }

  onClickTabUpdate = value => {
    this.setState({activeTabId: value})
  }

  onClickAppItemUpdate = value => {
    this.setState({activeappId: value})
  }

  render() {
    const {activeTabId, searchInput, activeAppId} = this.state
    const filteredAppsList = this.getFilteredApps()
    const searchedAppsList = this.getSearchResults()

    return (
      <div className="bg-container">
        <Header  />
        <div className="search-container">
          <input
            type="search"
            className="search"
            onChange={this.onChangeSearchInput}
          />
          <img
            src="https://assets.ccbp.in/frontend/react-js/app-store/app-store-search-img.png"
            alt="search icon"
            className="search-icon"
          />
        </div>
        <ul className="tabs-container">
          {tabsList.map(eachItem => (
            <TabItem
              tabDetails={eachItem}
              key={eachItem.tabId}
              onClickTabUpdate={this.onClickTabUpdate}
              isActive={eachItem.tabId === activeTabId}
            />
          ))}
        </ul>
        <ul className="apps-container">
          {searchedAppsList.map(eachItem => (
            <AppItem 
              appDetails={eachItem} 
              key={eachItem.appId} 
              onClickAppItemUpdate={this.onClickAppItemUpdate}
              isActive={eachItem.appId === activeAppId}
              />
          ))}
        </ul>
      </div>
    )
  }
}

export default AppStore
